export default __webpack_public_path__ + "static/media/phon-book.24ddcbe0.svg";